import React from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import { Table } from 'antd';

const store = ['modeListStore'];
@inject(...store)
@observer
class App extends React.Component {

  render() {
    const { prefixCls, modeListStore: { appDetail }  } = this.props;
    const dev = toJS(appDetail) && toJS(appDetail).app ? toJS(appDetail).app.docfile : [];
    const columns = [
      { title: '方案名称', dataIndex: 'name', key: 'name', },
      { title: '操作', dataIndex: 'url', key: 'url', render: text => (<a href={text} target="_blank">下载</a>) }
    ];
    return (
      <div className={prefixCls}>
				<Table dataSource={dev} columns={columns} bordered={true} />
      </div>
    )
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/mode/appDetail/Solution.js